// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gf-0";